import React from "react";

function TwitterIcon() {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 21 19" fill="none"><path d="M16.0355 0.665833H18.9873L12.5385 8.03639L20.125 18.0661H14.1848L9.53228 11.9831L4.2087 18.0661H1.25513L8.15275 10.1824L0.875 0.665833H6.96597L11.1715 6.22587L16.0355 0.665833ZM14.9995 16.2993H16.6351L6.07722 2.33982H4.32203L14.9995 16.2993Z" fill="black"></path></svg>
  );
}

export default TwitterIcon;